import Vue from 'vue'

import uiCheckbox from './src/ui-checkbox.vue';

Vue.component('ui-checkbox', uiCheckbox);

export default uiCheckbox;



//////////////////
// WEBPACK FOOTER
// ./~/ui-components/~/ui-checkbox/index.js
// module id = 545
// module chunks = 0